module.exports = __webpack_public_path__ + "img/ck6.f35bbd2d.png";